// extracted by mini-css-extract-plugin
export var required = "_ex-0";